import { NJSpinner } from '@engie-group/fluid-design-system-react';

export const Spinner: React.FC = () => {
  return (
    <div data-testid="spinner-component" className="d-flex justify-content-center align-items-center h-full">
      <NJSpinner isLoading />
    </div>
  );
};
